import { createPluginFactory, onKeyDownToggleMark } from '@udecode/plate-core';

const MARK_KBD = 'kbd';
/**
 * Enables support for code formatting
 */

const createKbdPlugin = createPluginFactory({
  key: MARK_KBD,
  isLeaf: true,
  handlers: {
    onKeyDown: onKeyDownToggleMark
  },
  deserializeHtml: {
    rules: [{
      validNodeName: ['KBD']
    }, {
      validStyle: {
        wordWrap: 'break-word'
      }
    }]
  }
});

export { MARK_KBD, createKbdPlugin };
//# sourceMappingURL=index.es.js.map
